import { render } from "./ProfileEdit.vue?vue&type=template&id=87ac86b6&scoped=true"
import script from "./ProfileEdit.vue?vue&type=script&lang=js"
export * from "./ProfileEdit.vue?vue&type=script&lang=js"

import "./ProfileEdit.vue?vue&type=style&index=0&id=87ac86b6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87ac86b6"]])

export default __exports__